import { lazy } from "react";
import { TEACHER_JOURNEY_URL } from "../constants";

import SubscriptionSection from "../pages/teacherJourney/subscriptions/index.js";
import TeacherNotifications from "../pages/teacherJourney/notifications/index.jsx";

// Lazy loaded components
const TeacherMessages = lazy(() =>
  import("../pages/teacherJourney/teacher-messages")
);
const TeacherMeetings = lazy(() =>
  import("../pages/teacherJourney/teacher-meetings")
);
const TeacherOffers = lazy(() =>
  import("../pages/teacherJourney/teacher-offers")
);
const TeachingBoard = lazy(() =>
  import("../pages/teacherJourney/teaching-board")
);
const TeacherJourneyCourse = lazy(() =>
  import("../pages/teacherJourney/TeacherCourseNew")
);
const TeacherDocuments = lazy(() =>
  import("../pages/teacherJourney/teacher-documents")
);
const TeacherJourneyEducation = lazy(() =>
  import("../pages/teacherJourney/TeacherEducation")
);
const TeacherJourneyExperience = lazy(() =>
  import("../pages/teacherJourney/TeacherExperience")
);
const TeacherJourneyMode = lazy(() =>
  import("../pages/teacherJourney/TeacherModeofEducation")
);
const TeacherJourneyMemberShip = lazy(() =>
  import("../pages/teacherJourney/TeacherMembership/index.js")
);
const TeacherJourneySlots = lazy(() =>
  import("../pages/teacherJourney/TeacherSlots")
);
const TeacherJourneyProfile = lazy(() =>
  import("../pages/teacherJourney/TeacherProfile")
);
const TeacherProfilePreview = lazy(() =>
  import("../pages/teacherJourney/profile-preview")
);
const WalletSummary = lazy(() => import("../pages/wallet"));
const UserSuccessCheckoutPage = lazy(() =>
  import("../pages/user-success-checkout-page")
);

export const teacherRoutes = [
  {
    path: TEACHER_JOURNEY_URL,
    component: TeacherMeetings,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/profile-preview`,
    component: TeacherProfilePreview,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/messages`,
    component: TeacherMessages,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/offers`,
    component: TeacherOffers,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/teaching-boards`,
    component: TeachingBoard,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/courses`,
    component: TeacherJourneyCourse,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/documents`,
    component: TeacherDocuments,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/education`,
    component: TeacherJourneyEducation,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/experience`,
    component: TeacherJourneyExperience,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/modeOfTeaching`,
    component: TeacherJourneyMode,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/slot`,
    component: TeacherJourneySlots,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/subscription`,
    component: SubscriptionSection,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/settings`,
    component: TeacherJourneyProfile,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/payment`,
    component: TeacherJourneyMemberShip,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/wallet-summary`,
    component: WalletSummary,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/checkout-success`,
    component: UserSuccessCheckoutPage,
    protected: "",
  },
  {
    path: `${TEACHER_JOURNEY_URL}/notifications`,
    component: TeacherNotifications,
    protected: "",
  },
];
